import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar_1 from "./Project_Navbar/Navbar_1";
import SidebarDD from "./SideBar/SidebarDD";
import Sidebar from "./SideBar/Sidebar";
import Preview from "./Preview/Preview";
import Options from "./Options/Options";
import Footer from "./Footer/Footer";
import { CelebrationFinal, Scrollx_animate } from "../../assets/icons";

import "./Project.css";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getProjectDetails } from "../../Redux/actions/projectActions";
import { Loader } from "../../Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import {
  skipUserModel,
  getCurrentPlan,
  getDefalutLogos,
  getNotification,
  addNotifications,
  userSeenTutorial,
} from "../../Redux/actions/commonActtion";
import "./ProjectPOPUP.css";
import { toast } from "react-toastify";
import CustomToast, {
  customToatStyle,
} from "../../Components/CustomToast/CustomToast";
import { getCurrentNotification } from "../utils/global";
import LoaderGlobal from "../../Components/Loader/LoaderGlobal";
export default function Project() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [isTitleSafe, setIsTitleSafe] = useState(false);
  const [isScrBound, setIsScrBound] = useState(false);
  const [aspectRatio_FrameSize, setAspectRatio_FrameSize] = useState("None");
  const [reLoading, setReLoading] = useState({ condn: false, label: "" });
  const [selectRatio, setSelectRatio] = useState(false);
  const [savedSaving, setSavedSaving] = useState("");
  const isRederFinished = useSelector(
    (state) => state.commonReducer.isRederFinished
  );
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loadOnProjectFetch, setLoadOnProjectFetch] = useState(true);
  const millisecondsToWait = 1 * 60 * 1000;

  useEffect(() => {
    SyncProject();
    getAllDefaultLogos();
  }, [reLoading]);

  const getAllDefaultLogos = async () => dispatch(getDefalutLogos());

  const SyncProject = async () => {
    const res = await dispatch(getProjectDetails(projectId));
    dispatch(getCurrentPlan());
    return res;
  };

  const fetchProjectDetails = async () => {
    setLoadOnProjectFetch(true);
    try {
      const res = await dispatch(getProjectDetails(projectId)).then((res) => {
        setLoadOnProjectFetch(false);
      });
      dispatch(getCurrentPlan());
      return res;
    } catch (err) {
      alert("Something went wrong");
    }
  };

  useEffect(() => {
    fetchProjectDetails();
  }, []);

  const getBlockSize = (asd, val) => {
    setAspectRatio_FrameSize(val);
    switch (val) {
      case "hdClass":
        return setAspectRatio_FrameSize(val);

      case "fhdClass":
        return setAspectRatio_FrameSize(val);

      case "qhdClass":
        return setAspectRatio_FrameSize(val);

      default:
        return "deafult";
    }
  };

  const getStorageData = JSON.parse(localStorage.getItem("skipModels"));
  const [isFivePop, setIsFivePop] = useState(
    getStorageData ? getStorageData.layoutModalstatus : true
  );
  const [isSixPop, setIsSixPop] = useState(false);
  const [isSevenPop, setIsSevenPop] = useState(false);
  const [isEightPop, setIsEightPop] = useState(false);
  const [isNinePop, setIsNinePop] = useState(false);
  const [isTenPop, setIsTenPop] = useState(false);
  const [isElevenPop, setIsElevenPop] = useState(false);
  const [isTwelvePop, setIsTwelvePop] = useState(false);

  const updateTutorialStatus = async (status) => {
    await dispatch(userSeenTutorial(status));
  };

  const nextToContinue = (key, val, status) => {
    if (key === "creditStarted") {
      setIsFivePop(false);
      setIsSixPop(true);
    } else if (key === "syncCredit") {
      setIsSixPop(false);
      setIsSevenPop(true);
    } else if (key === "RealTimePreview") {
      setIsSevenPop(false);
      setIsEightPop(true);
    } else if (key === "layoutOptions") {
      setIsEightPop(false);
      setIsNinePop(true);
    } else if (key === "fontOptions") {
      setIsNinePop(false);
      setIsTenPop(true);
    } else if (key === "AspectRatio") {
      setIsTenPop(false);
      setIsElevenPop(true);
    } else if (key === "renderClick") {
      setIsElevenPop(false);
      setIsTwelvePop(true);
    }
    updateTutorialStatus(status);
  };

  const skipModel = async () => {
    dispatch(
      skipUserModel({ dashModalStatus: false, layoutModalstatus: false })
    );
    setIsFivePop(false);
    localStorage.setItem(
      "skipModels",
      JSON.stringify({ dashModalStatus: false, layoutModalstatus: false })
    );
    setIsFivePop(false);
    setIsSixPop(false);
    setIsSevenPop(false);
    setIsEightPop(false);
    setIsNinePop(false);
    setIsTenPop(false);
    setIsElevenPop(false);
    setIsTwelvePop(false);
  };

  const returnOnDashboard = () => {
    skipModel();
    navigate("/dashboard");
  };

  const projectData = useSelector((state) => state.project);
  // console.log('projectData == ',projectData);
  const blocks = projectData?.credits?.map((credit) => ({
    block_name: credit.options.block_name,
    block_type: credit.options.block_type,
    _id: credit._id,
  }));

  const currentBlockId = projectData?.currentBlock?.id;

  const currentBlockIdx = projectData?.credits?.findIndex(
    (credit) => credit._id === currentBlockId
  );

  const currentBlockOptions = ![undefined, -1].includes(currentBlockIdx)
    ? projectData?.credits[currentBlockIdx]?.options
    : {};

  const { previewWidth } = useSelector((state) => state?.application);

  async function renderRandomCall() {
    const filtr = projectData.renders.filter((render) => {
      return (
        render !== null &&
        render !== undefined &&
        render.isRederFinished === false
      );
    });

    if (filtr?.length === 0) return;
    const res = await fetchProjectDetails();
    let result = res?.data?.project?.renders;
    const renderFinished = result?.filter((render) => {
      return (
        render !== null &&
        render !== undefined &&
        render?.isRederFinished === false
      );
    });

    if (renderFinished?.length === 0) {
      toast(
        <CustomToast
          title=""
          content={
            "Your export has been completed! Please check the render page and proceed to download."
          }
        />,
        customToatStyle
      );
      const noti = getCurrentNotification();

      const payload = {
        project_id: noti.project_id,
        render_id: noti.render_id,
        message: `Render in progress ${noti.details.videoFilename}`,
        status: 1,
        user_id: noti.user_id,
      };

      await dispatch(addNotifications(payload));
      await dispatch(getNotification());
      return;
    }
  }

  useEffect(() => {
    let timer = setInterval(renderRandomCall, millisecondsToWait);
    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    dispatch(getNotification());
  }, []);

  // Function to handle fullscreen change
  const onFullscreenChange = () => {
    setIsFullscreen(!!document.fullscreenElement);
  };
  // Effect to add and clean up fullscreen change event listeners
  useEffect(() => {
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("mozfullscreenchange", onFullscreenChange); // Firefox
    document.addEventListener("webkitfullscreenchange", onFullscreenChange); // Chrome, Safari, and Opera
    document.addEventListener("msfullscreenchange", onFullscreenChange); // IE/Edge
    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("mozfullscreenchange", onFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        onFullscreenChange
      );
      document.removeEventListener("msfullscreenchange", onFullscreenChange);
    };
  }, []);

  // Function to enter fullscreen mode
  const enterFullscreen = () => {
    const previewContainer = document.getElementById("preview-container");
    if (previewContainer.requestFullscreen) {
      previewContainer.requestFullscreen();
    } else if (previewContainer.mozRequestFullScreen) {
      // Firefox
      previewContainer.mozRequestFullScreen();
    } else if (previewContainer.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      previewContainer.webkitRequestFullscreen();
    } else if (previewContainer.msRequestFullscreen) {
      // IE/Edge
      previewContainer.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
  };

  const handleFooterClick = () => {
    // console.log('Preview Call')
    if (isFullscreen) {
      // console.log('Preview = ',isFullscreen)
      exitFullscreen();
    } else {
      // console.log('Preview Elese , ', isFullscreen)
      enterFullscreen();
    }
  };

  return (
    <>
      {loadOnProjectFetch && (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80 LoadOnProjectimg"
            width="140px"
            height="140px"
          />
          {/* <LoaderGlobal /> */}
        </div>
      )}

      {reLoading?.condn ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="140px"
            height="140px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Syncing...</p>
        </div>
      ) : null}

      <div className="wlcmProjectContainer">
        <div className="projectContainer">
          <div className="projectHead">
            <Navbar_1
              titleName={projectData?.title}
              setReLoading={setReLoading}
              savedSaving={savedSaving}
              isRederFinished={isRederFinished}
            />
          </div>

          <div className="projectBody">
            <div className="sideNav">
              <SidebarDD
                currentBlockId={currentBlockId}
                blocks={blocks}
                projectData={projectData}
              />
            </div>

            <div
              className="preview"
              id="preview-container"
              style={{
                // width: `${previewWidth}px`,
                // minWidth: `${previewWidth}px`,
                backgroundColor: "#080808",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
                borderRadius: "0 0 10px 10px",
              }}
            >
              <div
                className={
                  isFullscreen
                    ? aspectRatio_FrameSize === "Class1x33"
                      ? "Class1x33Preview"
                      : aspectRatio_FrameSize === "Class2x39"
                      ? "Class2x39Preview"
                      : aspectRatio_FrameSize === "Class1x78"
                      ? "Class1x78Preview"
                      : aspectRatio_FrameSize === "Class1x85"
                      ? "Class1x85Preview"
                      : aspectRatio_FrameSize === "Class1x9"
                      ? "Class1x9Preview"
                      : aspectRatio_FrameSize === "Class2_35x1"
                      ? "Class2_35x1Preview"
                      : "w-full h-full"
                    : aspectRatio_FrameSize === "Class1x33"
                    ? "Class1x33"
                    : aspectRatio_FrameSize === "Class2x39"
                    ? "Class2x39"
                    : aspectRatio_FrameSize === "Class1x78"
                    ? "Class1x78"
                    : aspectRatio_FrameSize === "Class1x85"
                    ? "Class1x85"
                    : aspectRatio_FrameSize === "Class1x9"
                    ? "Class1x9"
                    : aspectRatio_FrameSize === "Class2_35x1"
                    ? "Class2_35x1"
                    : "h-full RespPreviewClass"
                }
                style={{
                  borderLeft: isTitleSafe ? "2px dashed #5F5F5F" : "",
                  borderRight: isTitleSafe ? "2px dashed #5F5F5F" : "",
                }}
              >
                <Preview
                  projectData={projectData}
                  isFullscreen={isFullscreen}
                  exitFullscreen={exitFullscreen}
                />
              </div>
            </div>

            <div className="options">
              <Options
                currentBlockOptions={currentBlockOptions}
                currentBlockIdx={currentBlockIdx}
                currentBlockId={currentBlockId}
                setReLoading={setReLoading}
              />
            </div>
          </div>

          <div className="projectFooter">
            <Footer
              currentBlockOptions={currentBlockOptions}
              isTitleSafe={isTitleSafe}
              setIsTitleSafe={setIsTitleSafe}
              isScrBound={isScrBound}
              setIsScrBound={setIsScrBound}
              selectRatio={selectRatio}
              setSelectRatio={setSelectRatio}
              getBlockSize={getBlockSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              handleFooterClick={handleFooterClick}
            />
          </div>
        </div>

        {/* ==============(8  Congratulations POPUP)============== */}

        <div
          className={
            isTwelvePop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isTwelvePop && (
          <div className="TwelveProjectContent">
            <div className="text-white FontFamily-Avenir-reg">
              <div className="flex items-center justify-center gap-4 w-auto mr-[2.2rem] mb-[1.5rem]">
                <img
                  className="lg:w-16 lg:h-16 md:w-14 md:h-14"
                  src={CelebrationFinal}
                />
                <h1 className="Syne700 header font-bold text-5xl text-center">
                  Congratulations
                </h1>
              </div>
              <div className="para flex items-center justify-center flex-col mt-1">
                <p className="text-[1.2rem]">
                  You've just completed your ScrollX welcome guide.
                </p>
                <p className="text-[1.2rem]">
                  If you have any questions or need assistance,
                </p>
                <p className="text-[1.2rem]">
                  check out our FAQs or reach out to our support team.
                </p>
                <p className="happy font-semibold text-[1.4rem] mt-[0.5rem]">
                  Happy scrolling!
                </p>
              </div>

              <div className="pt-2 flex flex-col items-center justify-center mt-[1.2rem]">
                {/* <button
                  className="px-3 py-[5px] text-xl   welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button> */}
                <button
                  className="POPnextbtn py-[0.7rem] px-[0.9rem] text-lg mx-2 rounded-xl"
                  onClick={returnOnDashboard}
                >
                  Return To Dashboard
                </button>
                <div className="text-base tracking-wide p-2">or</div>
                <button
                  className=" py-[0.6rem] px-[0.9rem] text-lg rounded-xl"
                  onClick={skipModel}
                >
                  Continue Editing
                </button>
              </div>
              {/* <div className="projecTtriangleTen"></div> */}
            </div>
          </div>
        )}

        {/* ==============(7  Render Click POPUP)============== */}

        <div
          className={
            isElevenPop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isElevenPop && (
          <div className="ElevenProjectContent projecTtriangleELeven">
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px]  text-left">
                  Let’s Hit Renders
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left">
                Once you are ready, let’s render your end credits in the desired
                format.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl   welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px]  text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("renderClick", val, 7)}
                >
                  Next
                </button>
              </div>
              {/* <div className="projecTtriangleTen"></div> */}
            </div>
          </div>
        )}

        {/* ==============(6  Aspect Ratio POPUP)============== */}

        <div
          className={
            isTenPop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isTenPop && (
          <div className="TenProjectContent projecTtriangleTen">
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px] text-left">
                  Preview your Aspect Ratio
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left">
                Select your desired aspect ratio to preview. You can change
                gutter size as well.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl   welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("AspectRatio", val, 6)}
                >
                  Next
                </button>
              </div>
              {/* <div className="projecTtriangleTen"></div> */}
            </div>
          </div>
        )}

        {/* ==============(5  Font Options POPUP)============== */}

        <div
          className={
            isNinePop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isNinePop && (
          <div className="NineProjectContent projecTtriangleNine">
            {/* <div className="projecTtriangle"></div> */}
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px] text-left">
                  Change Fonts Easily
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left">
                Simply customize the font, size, color and spacing.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("fontOptions", val, 5)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ==============(4  Layout Options POPUP)============== */}

        <div
          className={
            isEightPop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isEightPop && (
          <div className="EightProjectContent projecTtriangleEight">
            {/* <div className="projecTtriangle"></div> */}
            <div className="text-white FontFamily-Avenir-reg px-3">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px] text-left cursor-default">
                  Change Layout Easily
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left cursor-default">
                Customize the layout, alignment, arrangement and more. You can
                also add heading and subheading.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("layoutOptions", val, 4)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ==============(3  Real Time Preview POPUP)============== */}

        <div
          className={
            isSevenPop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isSevenPop && (
          <div className="SevenProjectContent projecTtriangleSeven">
            {/* <div className="projecTtriangleSeven"></div> */}
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px] text-left">
                  Real-time Preview
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left cursor-default">
                See your credits sync real-time once you have clicked Sync.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl   welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("RealTimePreview", val, 3)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ==============(2  Sync Credits POPUP)============== */}

        <div
          className={
            isSixPop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isSixPop && (
          <div className="SixProjectContent projecTtrianglesix">
            {/* <div className="projecTtrianglesix"></div> */}
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px]  text-left">
                  Let Scrollx sync your Credits
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left cursor-default">
                Once you’ve updated the sheet with your credits, hit Sync for
                Scrollx to load your credits here.
              </p>
              <p className="pt-1 text-left yellow-50">You can Sync anytime.</p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("syncCredit", val, 2)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ==============(1  Enter Credits POPUP)============== */}

        <div
          className={
            isFivePop === true ? "wlcmProjectOverlay" : "wlcmOverlayNone"
          }
        ></div>

        {isFivePop && (
          <div className="fiveProjectContent projecTtriangle">
            {/* <div className="projecTtriangle"></div> */}
            <div className="text-white FontFamily-Avenir-reg px-3 cursor-default">
              <div className="flex items-center justify-left pb-3">
                <h1 className="Syne700 font-bold text-[27px]  text-left">
                  Enter your Credits here.
                </h1>
              </div>
              {/* <br /> */}
              <p className="text-base text-left cursor-default">
                You can write your credits and roles at our integrated google
                sheet. You can edit this anytime during your process.
              </p>
              <div className="pt-4 flex items-center justify-end">
                <button
                  className="px-3 py-[5px] text-xl   welPrjctStartbtn rounded-xl"
                  onClick={skipModel}
                >
                  Skip
                </button>

                <button
                  className="px-3 py-[5px] text-xl  mx-2 POPnextbtn rounded-xl"
                  onClick={(val) => nextToContinue("creditStarted", val, 1)}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
